import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	relationShip: null,
	error: "",
	loading: false,
};

// ADD_relationShip
export const addRelationShip = createAsyncThunk(
	"relationShip/addRelationShip",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `relationShip`,
				data: {
					...values,
				},
			});
			toast.success("Relationship added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Relationship try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_relationShip
export const deleteRelationShip = createAsyncThunk(
	"relationShip/deleteRelationShip ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `relationShip/${id}`,
			});

			toast.success("Relationship deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting relationShip try again");
			console.log(error.message);
		}
	}
);


// relationShipS
export const getAllRelationShip = createAsyncThunk(
	"relationShip/getAllRelationShip",
	async () => {
		try {
			const { data } = await axios.get(`relationShip`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateRelationShip = createAsyncThunk(
	"relationShip/updateRelationShip",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `relationShip/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Relationship updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Relationship try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const relationShipSlice = createSlice({
	name: "relationShip",
	initialState,
	reducers: {
		clearRelationShip: (state) => {
			state.relationShip = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllRelationShip ======

		builder.addCase(getAllRelationShip.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllRelationShip.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllRelationShip.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addRelationShip  ======

		builder.addCase(addRelationShip.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addRelationShip.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addRelationShip.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for relationShip ======

		builder.addCase(updateRelationShip.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateRelationShip.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateRelationShip.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteRelationShip  ======

		builder.addCase(deleteRelationShip.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteRelationShip.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteRelationShip.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default relationShipSlice.reducer;
export const { clearRelationShip } = relationShipSlice.actions;
